import { A11yToggle } from './A11yToggle';

export default document.addEventListener('DOMContentLoaded', () => {
  const burgerButtonEl = document.querySelector('#burger-toggle');
  const burgerTargetEl = document.querySelector('#burger-target');
  const burgerMenuListEl = burgerButtonEl.nextElementSibling;

  new A11yToggle({
    triggerEl: burgerButtonEl,
    targetEl: burgerTargetEl,
    textEl: burgerButtonEl.querySelector('span.visually-hidden'),
    openText: 'Open menu',
    closeText: 'Close menu',
    triggerActiveClasses: ['nav__toggle--open'],
    targetActiveClasses: ['header__inner--expanded'],
    beforeShow() {
      // Show the menu items before transition
      burgerMenuListEl.style.display = '';
    },
    afterHide() {
      // Hide the menu items after transition
      burgerMenuListEl.style.display = 'none';
    },
  });
});
